<template>
  <div>
    <edit-popup-content-view :popup-content-prop="newPopupContent"></edit-popup-content-view>
  </div>
</template>

<script>

import EditPopupContentView from "@/views/popup/EditPopupContentView";

export default {
  name: 'NewPopupContentView',

  components: {
    EditPopupContentView
  },

  data() {
    return {
      newPopupContent: {
        name: '',
        design: null,
        status: 'DRAFT'
      }
    }
  }
}
</script>

<style scoped>
</style> 